import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import NumberUtils from '../../utils/NumberUtils';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work can improve this.
 */
class TransactionRowTemplate extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(columnClicked) {
    this.props.customClick(
      this.props.rowData,
      this.props.rowIndex,
      columnClicked
    );
  }

  render() {
    const rowData = this.props.rowData;
    const metaData = this.props.metadata;
    const index = rowData.accIndex;
    let colData;
    if (metaData.columnName === 'date') {
      const tagDate = moment(rowData.date).format('DD MMM YY');
      colData = (
        <span onClick={() => this.onClick(metaData.columnName)}>{tagDate}</span>
      );
    }
    if (metaData.columnName === 'description') {
      colData = (
        <span
          onClick={() => this.onClick(metaData.columnName)}
          className={`account-${index}`}
        >
          {rowData.description}
        </span>
      );
    }
    if (metaData.columnName === 'type') {
      colData = (
        <span onClick={() => this.onClick(metaData.columnName)}>
          {rowData.type}
        </span>
      );
    }
    if (metaData.columnName === 'tag') {
      if (rowData.tag === 'Untagged') {
        colData = (
          <span onClick={() => this.onClick(metaData.columnName)}>&nbsp;</span>
        );
      } else {
        colData = (
          <span
            onClick={() => this.onClick(metaData.columnName)}
            className="icon icon-tag"
          >
            {rowData.tag}
          </span>
        );
      }
    }
    if (metaData.columnName === 'amount') {
      const amount = NumberUtils.appendCurrency(
        '{}',
        rowData.amount,
        rowData.currency
      );
      colData = (
        <span onClick={() => this.onClick(metaData.columnName)}>
          <strong>{amount}</strong>
        </span>
      );
    }
    if (metaData.columnName === 'account') {
      if (rowData.inProgress) {
        colData = (
          <span className={`has-inprogress account-${index}`}>
            {rowData.accName}{' '}
            <button
              className="btn btn-link"
              onClick={() => this.onClick(metaData.columnName)}
            >
              <i className="icon icon-waiting" />
            </button>
          </span>
        );
      } else {
        colData = (
          <span
            onClick={() => this.onClick(metaData.columnName)}
            className={`account-${index}`}
          >
            {rowData.accName}
          </span>
        );
      }
    }
    return <div>{colData}</div>;
  }
}

TransactionRowTemplate.propTypes = {
  rowData: PropTypes.object,
  metadata: PropTypes.object,
  customClick: PropTypes.func,
};

export { TransactionRowTemplate };
